import { createFileRoute } from '@tanstack/react-router';

import { SectionPlaceholder } from '@/shared/ui/SectionPlaceholder';

export const Route = createFileRoute('/_app/blog')({
  component: () => <SectionPlaceholder title="Блог" icon="blog" />,
});
